import { createReducer } from "typesafe-actions";

import CumulAuth from "@mapmycustomers/shared/types/cumul/CumulAuth";
import CumulDashboard from "@mapmycustomers/shared/types/cumul/CumulDashboard";

import {
  Actions,
  createDashboard,
  duplicateDashboard,
  fetchDashboardList,
  hideDashboard,
  initializeCumul,
  saveSharing,
  showDashboard,
} from "./actions";

export type CumulState = {
  cumulAuth?: CumulAuth;
  cumulDashboardList?: CumulDashboard[];
  dashboardIdToOpen?: CumulDashboard["id"];
  saving: boolean;
};

const initialState: CumulState = {
  saving: false,
};

const cumul = createReducer<CumulState, Actions>(initialState)
  .handleAction(initializeCumul.request, (state) => ({
    ...state,
  }))
  .handleAction(initializeCumul.success, (state, { payload }) => ({
    ...state,
    cumulAuth: payload,
  }))
  .handleAction(initializeCumul.failure, (state) => ({
    ...state,
  }))
  .handleAction(fetchDashboardList.request, (state) => ({
    ...state,
  }))
  .handleAction(fetchDashboardList.success, (state, { payload }) => ({
    ...state,
    cumulDashboardList: payload,
  }))
  .handleAction(fetchDashboardList.failure, (state) => ({
    ...state,
  }))
  .handleAction(showDashboard, (state, { payload }) => ({
    ...state,
    dashboardIdToOpen: payload,
  }))
  .handleAction(hideDashboard, (state) => ({
    ...state,
    dashboardIdToOpen: undefined,
  }))
  .handleAction(duplicateDashboard.request, (state) => ({
    ...state,
  }))
  .handleAction(duplicateDashboard.success, (state, { payload }) => ({
    ...state,
    dashboardIdToOpen: payload.id,
  }))
  .handleAction(duplicateDashboard.failure, (state) => ({
    ...state,
  }))
  .handleAction(createDashboard.request, (state) => ({
    ...state,
  }))
  .handleAction(createDashboard.success, (state, { payload }) => ({
    ...state,
    dashboardIdToOpen: payload.id,
  }))
  .handleAction(createDashboard.failure, (state) => ({
    ...state,
  }))
  .handleAction(saveSharing.request, (state) => ({
    ...state,
    saving: true,
  }))
  .handleAction(saveSharing.success, (state, { payload }) => ({
    ...state,
    cumulDashboardList: state.cumulDashboardList?.map((dashboard) =>
      dashboard.id === payload.id ? payload : dashboard
    ),
    saving: false,
  }))
  .handleAction(saveSharing.failure, (state) => ({
    ...state,
    saving: false,
  }));

export * from "./selectors";
export type CumulActions = Actions;
export default cumul;
